/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'commerce.credit-card-hams.brand-validation.error': 'Only Visa, MasterCard and AMEX are supported'
};